
// redux (action-types)
import {SAVE_SETTINGS} from 'redux/reducers/settings/app/action-types'


const saveSettings = (json) => ({type: SAVE_SETTINGS, json});


export {saveSettings}